<template>
  <div v-text="errorMessage || defaultError" />
</template>

<script>
export default {
  name: 'FailedPresentation',
  props: {
    errorMessage: {
      type: String,
    },
  },
  data() {
    return {
      defaultError: 'Не удалось сформировать презентацию',
    }
  },
}
</script>
